import React from 'react';
import AssignmentIndOutlinedIcon from '@material-ui/icons/AssignmentIndOutlined';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import LocationCityOutlinedIcon from '@material-ui/icons/LocationCityOutlined';
import PersonOutlineIcon from '@material-ui/icons/PersonOutline';
import PinDropOutlinedIcon from '@material-ui/icons/PinDropOutlined';
import VerifiedUserOutlinedIcon from '@material-ui/icons/VerifiedUserOutlined';
import AvailabilityCardItem from './AvailabilityCardItem';
import { ClickableCardButton } from '../DisponibilidadeFrota-styled';

const hasSelectedText = () => {
  if (typeof window === 'undefined' || typeof window.getSelection !== 'function') return false;
  return String(window.getSelection() || '').trim().length > 0;
};

const getStatusTone = value => (value === 'Disponivel' ? 'success' : 'danger');

const getMotoristaCardTitle = value => {
  const normalized = String(value || '').trim();
  if (!normalized) return value;

  const nameParts = normalized.split(/\s+/).filter(Boolean);
  if (nameParts.length === 1) return normalized;

  const firstName = nameParts[0];
  const firstSurname = nameParts[1];
  const firstAndSurname = `${firstName} ${firstSurname}`;
  const withEllipsis = displayValue => (displayValue === normalized ? displayValue : `${displayValue}...`);

  if (nameParts.length === 2) return normalized;
  if (firstAndSurname.length <= 16) return withEllipsis(firstAndSurname);
  if (firstName.length <= 14) return withEllipsis(`${firstName} ${firstSurname.charAt(0)}.`);

  return withEllipsis(firstName);
};

const MotoristaAvailabilityCard = ({ item, onSelect, selected, expanded, onExpandedChange } = {}) => {
  const handleSelect = () => {
    if (!onSelect || hasSelectedText()) return;
    onSelect(item);
  };

  const handleKeyDown = event => {
    if (!onSelect) return;
    if (event.key !== 'Enter' && event.key !== ' ') return;

    event.preventDefault();
    handleSelect();
  };

  return (
    <ClickableCardButton
      role={onSelect ? 'button' : undefined}
      tabIndex={onSelect ? 0 : undefined}
      aria-disabled={!onSelect}
      onClick={handleSelect}
      onKeyDown={handleKeyDown}
      $selected={selected}
      $disabled={!onSelect}
    >
      <AvailabilityCardItem
        title={getMotoristaCardTitle(item.motorista)}
        titleFontSize="clamp(13px, 1.25vw, 17px)"
        titleTooltip={item.motorista}
        selected={selected}
        headerIcon={<PersonOutlineIcon style={{ fontSize: 22, color: '#ffffff' }} />}
        headerBadgesJustify="flex-end"
        headerBadgesMinWidth="168px"
        headerBadge={{
          caption: 'Status',
          icon: <CheckCircleOutlineIcon style={{ fontSize: 11 }} />,
          label: item.disponivelLabel,
          tone: getStatusTone(item.disponivelLabel)
        }}
        summaryGridColumns="minmax(0, 1.35fr) minmax(72px, 0.5fr) minmax(0, 1.25fr)"
        summaryItems={[
          {
            icon: <LocationCityOutlinedIcon style={{ fontSize: 18, color: '#5f77a6' }} />,
            label: 'Cidade',
            value: item.cidade
          },
          {
            icon: <PinDropOutlinedIcon style={{ fontSize: 18, color: '#5f77a6' }} />,
            label: 'UF',
            value: item.estado
          },
          {
            icon: <AssignmentIndOutlinedIcon style={{ fontSize: 18, color: '#5f77a6' }} />,
            label: 'Gestor',
            value: item.gestor
          }
        ]}
        detailItems={[
          {
            icon: <VerifiedUserOutlinedIcon style={{ fontSize: 18, color: '#5f77a6' }} />,
            label: 'Categoria CNH',
            value: item.categoriaCNH
          }
        ]}
        expanded={expanded}
        onExpandedChange={onExpandedChange}
      />
    </ClickableCardButton>
  );
};

export default MotoristaAvailabilityCard;
